import Service from '../../services'
import Swal from "sweetalert2";

// initial state
const state = {

    // Research & Report
    allArticlePaginate: {},
    articleForm: {
        name_th: '',
        name_en: '',
        intro_th: '',
        intro_en: '',
        detail_th: '',
        detail_en: '',
        report_create_date: '',
        indexmanage_id: null,
        tag_id: [],
        industry_id: null,
        image_cover_path: '',
        image_share_path: '',
        is_display_overview: 0
    },


    // About
    aboutDesc: {
        description_th: '',
        description_en: ''
    }

};


// getters
const getters = {

};


// actions
const actions = {

    // Research & Report
    onGetAllArticlePaginate({ commit }, data) {
        return Service.dashboard.getAllArticlePaginate(data).then((res) => {
            commit('setAllArticlePaginate', res);
        });
    },

    onGetArticle({ commit }, data) {
        return Service.dashboard.getArticle(data).then((res) => {
            commit('setArticle', res);
        });
    },

    onCreateArticle({ commit }, data) {
        return Service.dashboard.createArticle(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'เพิ่มข้อมูลสำเร็จ',
            })
            // alert('เพิ่มข้อมูลสำเร็จ');
        });
    },

    onEditArticle({ commit }, data) {
        return Service.dashboard.editArticle(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'แก้ไขข้อมูลสำเร็จ',
            })
           // alert('แก้ไขข้อมูลสำเร็จ');
        });
    },

    onDeleteArticle({ commit }, data) {
        return Service.dashboard.deleteArticle(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'ลบข้อมูลสำเร็จ',
            })
            // alert('ลบข้อมูลสำเร็จ');
        });
    },


    // About
    onGetAboutDesc({ commit }, data) {
        return Service.dashboard.getAboutDesc(data).then((res) => {
            commit('setAboutDesc', res);
        });
    },

    onEditAboutDesc({ commit }, data) {
        return Service.dashboard.editAboutDesc(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'แก้ไขข้อมูลสำเร็จ',
            })
            // alert('แก้ไขข้อมูลสำเร็จ');
        });
    }

};


// mutations
const mutations = {

    // Research & Report
    setAllArticlePaginate(state, data) {
        state.allArticlePaginate = data;
    },

    setArticle(state, data) {
        state.articleForm = {
            name_th: data.name_th,
            name_en: data.name_en,
            intro_th: data.intro_th,
            intro_en: data.intro_en,
            detail_th: data.detail_th,
            detail_en: data.detail_en,
            report_create_date: data.report_create_date,
            indexmanage_id: data.indexmanage_id,
            tag_id: data.tag_options.map(tag => tag.id),
            industry_id: data.industry_id,
            image_cover_path: data.img_cover_path,
            image_share_path: data.img_share_path,
            is_display_overview: data.is_display_overview
        };
    },


    // About
    setAboutDesc(state, data) {
        state.aboutDesc = data;
    }

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
